import {
  FactoryProvider,
  InjectionToken,
  ModuleWithProviders,
  NgModule,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItkDjangoApi } from '@itk/universal-django-api';
import { NgDjangoHttpClient } from './http-client';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { of } from 'rxjs';

export const ITK_NG_DJANGO_API_CLIENT = new InjectionToken<symbol>(
  'Itk Angular Django API Client',
);

@NgModule({
  imports: [CommonModule, HttpClientModule],
})
export class ItkNgDjangoApiModule {
  public static forRoot(
    provider: Omit<FactoryProvider, 'provide' | 'multi'>,
  ): ModuleWithProviders<ItkNgDjangoApiModule> {
    return {
      ngModule: ItkNgDjangoApiModule,
      providers: [
        {
          ...provider,
          provide: 'DJANGO_API_CONFIG',
        },
        {
          provide: ITK_NG_DJANGO_API_CLIENT,
          deps: [HttpClient, 'DJANGO_API_CONFIG'],
          useFactory: (
            http: HttpClient,
            { rootUrl }: { rootUrl: string },
          ): ItkDjangoApi => {
            return new ItkDjangoApi(
              new NgDjangoHttpClient(http, rootUrl, () => of({})),
            );
          },
        },
      ],
    };
  }
}
